import AdvancedSearchFooter from './advanced-search-footer';

export type { AdvancedSearchFooterProps } from './advanced-search-footer';
export default AdvancedSearchFooter;
